import {ReactElement} from "react";
import {Condition} from "../AdvancedSearchControls";

export abstract class ConditionBase{


    constructor(public Options:any) {


    }




    public abstract GetComparisons():{Label:string,Value:string}[];

    public abstract GetValueEditor(editor:Condition,callback:()=>void):ReactElement;



}